import cls from "./styles.module.css";
import Loading from "../loading";
import { useInView } from "@/hooks/use-in-view";

type TPostsLoaderProps = {
  isFetching: boolean;
  fetchMore: () => any;
  hasMore: boolean;
};
export default function PostsLoader(props: TPostsLoaderProps) {
  const { ref } = useInView<HTMLDivElement>({
    rootMargin: "250px",
    onChange(inView) {
      if (inView && props.hasMore) {
        props.fetchMore();
      }
    },
  });
  return (
    <div className={cls.root} ref={ref}>
      {props.isFetching && <Loading />}
    </div>
  );
}
